import { VARIANTS } from '@jobcase/react_pattern_library/components/Toaster/Toaster';
import JobsAPI from '../../../../utils/api/jobsAPI';
import profilesActions from '../../entities/profiles/actions';
import { setNotification } from '../../notification/actions';

export const TYPES = {
  GET_CANDIDATES_REQUEST: 'jobCandidates/GET_CANDIDATES_REQUEST',
  GET_CANDIDATES_SUCCESS: 'jobCandidates/GET_CANDIDATES_SUCCESS',
  GET_CANDIDATES_ERROR: 'jobCandidates/GET_CANDIDATES_ERROR',
  GET_CANDIDATES_LOAD_MORE_REQUEST: 'jobCandidates/GET_CANDIDATES_LOAD_MORE_REQUEST',
  GET_CANDIDATES_LOAD_MORE_SUCCESS: 'jobCandidates/GET_CANDIDATES_LOAD_MORE_SUCCESS',
  GET_CANDIDATES_LOAD_MORE_ERROR: 'jobCandidates/GET_CANDIDATES_LOAD_MORE_ERROR',
  GET_CANDIDATE_DETAILS_REQUEST: 'jobCandidates/GET_CANDIDATE_DETAILS_REQUEST',
  GET_CANDIDATE_DETAILS_SUCCESS: 'jobCandidates/GET_CANDIDATE_DETAILS_SUCCESS',
  GET_CANDIDATE_DETAILS_ERROR: 'jobCandidates/GET_CANDIDATE_DETAILS_ERROR',
  HIDE_CANDIDATES_REQUEST: 'jobCandidates/HIDE_CANDIDATES_REQUEST',
  HIDE_CANDIDATES_SUCCESS: 'jobCandidates/HIDE_CANDIDATES_SUCCESS',
  HIDE_CANDIDATES_ERROR: 'jobCandidates/HIDE_CANDIDATES_ERROR',
  UNHIDE_CANDIDATES_REQUEST: 'jobCandidates/UNHIDE_CANDIDATES_REQUEST',
  UNHIDE_CANDIDATES_SUCCESS: 'jobCandidates/UNHIDE_CANDIDATES_SUCCESS',
  UNHIDE_CANDIDATES_ERROR: 'jobCandidates/UNHIDE_CANDIDATES_ERROR',
  GET_CANDIDATES_NOTES_LIST_REQUEST: 'jobCandidates/GET_CANDIDATES_NOTES_LIST_REQUEST',
  GET_CANDIDATES_NOTES_LIST_SUCCESS: 'jobCandidates/GET_CANDIDATES_NOTES_LIST_SUCCESS',
  GET_CANDIDATES_NOTES_LIST_ERROR: 'jobCandidates/GET_CANDIDATES_NOTES_LIST_ERROR',
  GET_CANDIDATES_MORE_NOTES_LIST_REQUEST: 'jobCandidates/GET_CANDIDATES_MORE_NOTES_LIST_REQUEST',
  GET_CANDIDATES_MORE_NOTES_LIST_SUCCESS: 'jobCandidates/GET_CANDIDATES_MORE_NOTES_LIST_SUCCESS',
  GET_CANDIDATES_MORE_NOTES_LIST_ERROR: 'jobCandidates/GET_CANDIDATES_NOTES_LIST_ERROR',
  CREATE_CANDIDATES_NOTE_REQUEST: 'jobCandidates/CREATE_CANDIDATES_NOTE_REQUEST',
  CREATE_CANDIDATES_NOTE_SUCCESS: 'jobCandidates/CREATE_CANDIDATES_NOTE_SUCCESS',
  CREATE_CANDIDATES_NOTE_ERROR: 'jobCandidates/CREATE_CANDIDATES_NOTE_ERROR',
  UPDATE_CANDIDATES_NOTE_REQUEST: 'jobCandidates/UPDATE_CANDIDATES_NOTE_REQUEST',
  UPDATE_CANDIDATES_NOTE_SUCCESS: 'jobCandidates/UPDATE_CANDIDATES_NOTE_SUCCESS',
  UPDATE_CANDIDATES_NOTE_ERROR: 'jobCandidates/UPDATE_CANDIDATES_NOTE_ERROR',
  RATE_CANDIDATE_REQUEST: 'jobCandidates/RATE_CANDIDATE_REQUEST',
  RATE_CANDIDATE_SUCCESS: 'jobCandidates/RATE_CANDIDATE_SUCCESS',
  RATE_CANDIDATE_ERROR: 'jobCandidates/RATE_CANDIDATE_ERROR',
  BULK_RATE_CANDIDATES_REQUEST: 'jobCandidates/BULK_RATE_CANDIDATES_REQUEST',
  BULK_RATE_CANDIDATES_SUCCESS: 'jobCandidates/BULK_RATE_CANDIDATES_SUCCESS',
  BULK_RATE_CANDIDATES_ERROR: 'jobCandidates/BULK_RATE_CANDIDATES_ERROR',
  RESET_NOTES_STATE: 'jobCandidates/RESET_NOTES_STATE',
  FORWARD_CANDIDATES_REQUEST: 'jobCandidates/FORWARD_CANDIDATES_REQUEST',
  FORWARD_CANDIDATES_SUCCESS: 'jobCandidates/FORWARD_CANDIDATES_SUCCESS',
  FORWARD_CANDIDATES_ERROR: 'jobCandidates/FORWARD_CANDIDATES_ERROR',
  SCREENER_ANSWERS_CANDIDATES_REQUEST: 'jobCandidates/SCREENER_ANSWERS_CANDIDATES_REQUEST',
  SCREENER_ANSWERS_CANDIDATES_SUCCESS: 'jobCandidates/SCREENER_ANSWERS_CANDIDATES_SUCCESS',
  SCREENER_ANSWERS_CANDIDATES_ERROR: 'jobCandidates/SCREENER_ANSWERS_CANDIDATES_ERROR',
};

export const getScreenerAnswers = candidatesId => async (dispatch) => {
  dispatch({ type: TYPES.SCREENER_ANSWERS_CANDIDATES_REQUEST });

  try {
    const screenerAnswersList = await JobsAPI().getScreenerAnswers(candidatesId);
    dispatch({ type: TYPES.SCREENER_ANSWERS_CANDIDATES_SUCCESS, payload: screenerAnswersList });
  } catch (error) {
    dispatch({ type: TYPES.SCREENER_ANSWERS_CANDIDATES_ERROR, payload: error });
    throw error;
  }
};

export const getAllCandidates = (options = {}) => async (dispatch) => {
  const isLoadMore = options?.isLoadMore || false;

  if (isLoadMore) {
    dispatch({ type: TYPES.GET_CANDIDATES_LOAD_MORE_REQUEST });
  } else {
    dispatch({ type: TYPES.GET_CANDIDATES_REQUEST });
  }

  try {
    const response = await JobsAPI().getCandidates(options);
    const candidatesProfileIds = response.content.map(candidate => candidate.profile_id);
    dispatch(profilesActions.getAllCompact({ data: candidatesProfileIds }));

    if (isLoadMore) {
      dispatch({ type: TYPES.GET_CANDIDATES_LOAD_MORE_SUCCESS, payload: response });
    } else {
      dispatch({ type: TYPES.GET_CANDIDATES_SUCCESS, payload: response });
    }

    return response;
  } catch (error) {
    if (isLoadMore) {
      dispatch({ type: TYPES.GET_CANDIDATES_LOAD_MORE_ERROR, payload: error });
    } else {
      dispatch({ type: TYPES.GET_CANDIDATES_ERROR, payload: error });
    }
    dispatch(setNotification('An error occurred while loading the candidates'));
    throw error;
  }
};

export const getCandidateDetails = (options = {}) => async (dispatch) => {
  dispatch({ type: TYPES.GET_CANDIDATE_DETAILS_REQUEST });

  try {
    const response = await JobsAPI().getCandidateDetails(options.candidateId);
    dispatch({ type: TYPES.GET_CANDIDATE_DETAILS_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_CANDIDATE_DETAILS_ERROR, payload: error });
    dispatch(setNotification('An error occurred while loading the candidate details'));
    throw error;
  }
};

export const hideCandidates = candidatesIdList => async (dispatch) => {
  dispatch({ type: TYPES.HIDE_CANDIDATES_REQUEST });

  try {
    await JobsAPI().hideCandidates(candidatesIdList);
    dispatch({ type: TYPES.HIDE_CANDIDATES_SUCCESS, payload: candidatesIdList });
  } catch (error) {
    dispatch({ type: TYPES.HIDE_CANDIDATES_ERROR, payload: error });
    throw error;
  }
};

export const unhideCandidates = candidatesIdList => async (dispatch) => {
  dispatch({ type: TYPES.UNHIDE_CANDIDATES_REQUEST });

  try {
    await JobsAPI().unhideCandidates(candidatesIdList);
    dispatch({ type: TYPES.UNHIDE_CANDIDATES_SUCCESS, payload: candidatesIdList });
  } catch (error) {
    dispatch({ type: TYPES.UNHIDE_CANDIDATES_ERROR, payload: error });
    throw error;
  }
};

export const getCandidatesNotesList = (id = '', options = {}, isLoadMore = false) => async (dispatch) => {
  if (isLoadMore) {
    dispatch({ type: TYPES.GET_CANDIDATES_MORE_NOTES_LIST_REQUEST });
  } else {
    dispatch({ type: TYPES.GET_CANDIDATES_NOTES_LIST_REQUEST });
  }

  try {
    const response = await JobsAPI().getCandidatesNotes(id, options);
    const profileIds = response.content?.map(({ author_profile_id: profileKey }) => profileKey);
    dispatch(profilesActions.getAllCompact({ data: profileIds }));
    if (isLoadMore) {
      dispatch({ type: TYPES.GET_CANDIDATES_MORE_NOTES_LIST_SUCCESS, payload: response });
    } else {
      dispatch({ type: TYPES.GET_CANDIDATES_NOTES_LIST_SUCCESS, payload: response });
    }
    return response;
  } catch (error) {
    if (isLoadMore) {
      dispatch({ type: TYPES.GET_CANDIDATES_MORE_NOTES_LIST_ERROR, payload: error });
    } else {
      dispatch({ type: TYPES.GET_CANDIDATES_NOTES_LIST_ERROR, payload: error });
    }
    dispatch(setNotification('An error occurred while loading the candidate notes'));
    throw error;
  }
};

export const createCandidateNote = (id = '', content = '') => async (dispatch) => {
  dispatch({ type: TYPES.CREATE_CANDIDATES_NOTE_REQUEST });
  try {
    const response = await JobsAPI().createCandidatesNote(id, content);
    dispatch({ type: TYPES.CREATE_CANDIDATES_NOTE_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.CREATE_CANDIDATES_NOTE_ERROR, payload: error });
    dispatch(setNotification('An error occurred while creating the note'));
    throw error;
  }
};

export const updateCandidateNote = (candidateId, noteId, noteContent) => async (dispatch) => {
  dispatch({ type: TYPES.UPDATE_CANDIDATES_NOTE_REQUEST });
  try {
    await JobsAPI().updateCandidatesNote(candidateId, noteId, noteContent);
    dispatch({ type: TYPES.UPDATE_CANDIDATES_NOTE_SUCCESS, payload: { noteId, content: noteContent } });
  } catch (error) {
    dispatch({ type: TYPES.UPDATE_CANDIDATES_NOTE_ERROR, payload: error });
    dispatch(setNotification('An error occurred while updating the note'));
    throw error;
  }
};

export const rateCandidate = (candidateId, data) => async (dispatch) => {
  dispatch({ type: TYPES.RATE_CANDIDATE_REQUEST });
  try {
    const response = await JobsAPI().rateCandidate(candidateId, data);
    dispatch({ type: TYPES.RATE_CANDIDATE_SUCCESS,
      payload: {
        candidateId,
        currentProfileRating: data.rating,
        averageRating: response.rating_average,
        ratingCount: response.rating_count,
        incrementNotesCount: !!data.note_content,
      },
    });
    dispatch(setNotification('You’ve rated this candidate', VARIANTS.SUCCESS));
  } catch (error) {
    dispatch({ type: TYPES.RATE_CANDIDATE_ERROR, payload: error });
    dispatch(setNotification('An error occurred while rating the candidate'));
    throw error;
  }
};

export const bulkRateCandidates = data => async (dispatch) => {
  dispatch({ type: TYPES.BULK_RATE_CANDIDATES_REQUEST });
  try {
    await JobsAPI().bulkRateCandidates(data);
    dispatch({
      type: TYPES.BULK_RATE_CANDIDATES_SUCCESS,
      payload: {
        rating: data.rating,
        candidateIds: data.candidate_ids,
      },
    });
  } catch (error) {
    dispatch({ type: TYPES.BULK_RATE_CANDIDATES_ERROR, payload: error });
    dispatch(setNotification('An error occurred while bulk rating the candidates'));
    throw error;
  }
};

export const resetNotesState = () => async (dispatch) => {
  dispatch({ type: TYPES.RESET_NOTES_STATE });
};

export const forwardCandidates = data => async (dispatch) => {
  dispatch({ type: TYPES.FORWARD_CANDIDATES_REQUEST });

  try {
    await JobsAPI().forwardCandidate(data);
    dispatch({ type: TYPES.FORWARD_CANDIDATES_SUCCESS });
  } catch (error) {
    dispatch({ type: TYPES.FORWARD_CANDIDATES_ERROR, payload: error });
    dispatch(setNotification('An error occurred while bulk forwarding the candidates'));
    throw error;
  }
};

export default {
  getScreenerAnswers,
  resetNotesState,
  getAllCandidates,
  getCandidatesNotesList,
  hideCandidates,
  createCandidateNote,
  updateCandidateNote,
  rateCandidate,
  unhideCandidates,
  bulkRateCandidates,
  forwardCandidates,
};
